import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_2 = { class: "mt-1 text-md text-gray-900" }
const _hoisted_3 = { class: "divide-y divide-gray-100" }
const _hoisted_4 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_5 = { class: "mt-1 text-md text-gray-900" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_8 = { class: "text-base font-semibold text-gray-900 flex items-center gap-x-1" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mt-2 max-w-xl text-md text-gray-500" }
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_17 = { class: "mt-1 text-md text-gray-900" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_20 = { class: "text-base font-semibold text-gray-900 flex items-center gap-x-1" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "mt-2 max-w-xl text-md text-gray-500" }
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = { class: "mt-2" }
const _hoisted_26 = { class: "mt-2" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "mt-5" }

import { ref, watch } from 'vue';
import { DialogTitle } from '@headlessui/vue';
import { useI18n } from 'vue-i18n';
import usePluginStore from '@/store/plugin/plugin';
import RightSideDrawer from '@/components/tailwind/shared/RightSideDrawer.vue';
import ListItemPluginIntegration from '@/components/tailwind/plugin/ListItemPluginIntegration.vue';
import InstagramLogo from '@/assets/images/logo-instagram.png';
import FacebookLogo from '@/assets/images/logo-facebook.svg';
import TiktokLogo from '@/assets/images/logo-tiktok.svg';
import YoutubeLogo from '@/assets/images/logo-youtube.svg';
import ShopifyLogo from '@/assets/images/logo-shopify.svg';


export default /*@__PURE__*/_defineComponent({
  __name: 'PluginConnectDrawer',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  // When set, skips the platform-chooser step and jumps straight to the
  // specific platform's connect drawer. Livvia uses this after already
  // asking the seller which network to connect. Undefined = classic
  // behaviour (open the platform chooser first).
  platform: {
    type: String as () => 'instagram' | 'facebook' | undefined,
    default: undefined,
  },
},
  emits: ['update:show'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n();
const { pluginStore } = usePluginStore();

const props = __props;

const emit = __emit;

const showCreateModal = ref(false);
const showInstagramConnectModal = ref(false);
const showFacebookConnectModal = ref(false);

watch(() => props.show, (newValue) => {
  if (newValue) {
    if (props.platform === 'instagram') {
      showInstagramConnectModal.value = true;
    } else if (props.platform === 'facebook') {
      showFacebookConnectModal.value = true;
    } else {
      showCreateModal.value = true;
    }
  }
});

watch(showCreateModal, (newValue) => {
  if (!newValue && !showInstagramConnectModal.value && !showFacebookConnectModal.value) {
    emit('update:show', false);
  }
});

watch(showInstagramConnectModal, (newValue) => {
  if (!newValue && !showCreateModal.value && !showFacebookConnectModal.value) {
    emit('update:show', false);
  }
});

watch(showFacebookConnectModal, (newValue) => {
  if (!newValue && !showCreateModal.value && !showInstagramConnectModal.value) {
    emit('update:show', false);
  }
});

const resetModals = () => {
  showCreateModal.value = false;
  showInstagramConnectModal.value = false;
  showFacebookConnectModal.value = false;
};

const instagramConnect = () => {
  resetModals();
  showInstagramConnectModal.value = true;
};

const instagramConnectClose = () => {
  resetModals();
  showCreateModal.value = true;
};

const facebookConnect = () => {
  resetModals();
  showFacebookConnectModal.value = true;
};

const facebookConnectClose = () => {
  resetModals();
  showCreateModal.value = true;
};

const instagramConnectStart = () => {
  const queryParams = [
    'client_id=1035072877787285',
    `redirect_uri=${encodeURIComponent(process.env.VUE_APP_INSTAGRAM_REDIRECT_URI || 'https://www.livelink.com.br/plugins/callback/instagram')}`,
    'response_type=code',
    'auth_type=reauthenticate',
    'prompt=consent',
    'display=popup',
  ];
  const instagramUrl = `https://www.instagram.com/oauth/authorize?${queryParams.join('&')}`;
  pluginStore.csrf = Math.random().toString(36).substring(2, 15);
  const scope = 'instagram_business_basic,instagram_business_manage_comments,instagram_business_manage_messages';
  window.location.href = `${instagramUrl}&state=${pluginStore.csrf}&scope=${scope}`;
};

const facebookConnectStart = () => {
  const queryParams = [
    'client_id=489268840559363',
    'redirect_uri=https://www.livelink.com.br/plugins/callback/facebook',
    'response_type=code',
  ];
  const facebookUrl = `https://www.facebook.com/v21.0/dialog/oauth?${queryParams.join('&')}`;
  pluginStore.csrf = Math.random().toString(36).substring(2, 15);
  const scope = 'pages_show_list,pages_read_engagement,pages_read_user_content,pages_manage_metadata,public_profile,email';
  window.location.href = `${facebookUrl}&state=${pluginStore.csrf}&scope=${scope}`;
};

const open = () => {
  showCreateModal.value = true;
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RightSideDrawer, {
      show: showCreateModal.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showCreateModal).value = $event)),
      "bg-color": "bg-gray-100"
    }, {
      header: _withCtx(() => [
        _createVNode(_unref(DialogTitle), { class: "px-4 py-6 sm:px-6" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('plugins.manager.create.title')), 1),
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('plugins.manager.create.description')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", _hoisted_3, [
          _createVNode(ListItemPluginIntegration, {
            logo: _unref(InstagramLogo),
            title: "Instagram",
            description: _unref(t)('plugins.manager.create.instagram.description'),
            "on-click": instagramConnect
          }, null, 8, ["logo", "description"]),
          _createVNode(ListItemPluginIntegration, {
            logo: _unref(FacebookLogo),
            title: "Facebook",
            description: _unref(t)('plugins.manager.create.facebook.description'),
            "availability-text": _unref(t)('plugins.manager.create.comingSoon'),
            "is-disabled": true,
            "on-click": facebookConnect
          }, null, 8, ["logo", "description", "availability-text"]),
          _createVNode(ListItemPluginIntegration, {
            logo: _unref(TiktokLogo),
            title: "Tiktok",
            description: _unref(t)('plugins.manager.create.tiktok.description'),
            "availability-text": _unref(t)('plugins.manager.create.comingSoon'),
            "is-disabled": true
          }, null, 8, ["logo", "description", "availability-text"]),
          _createVNode(ListItemPluginIntegration, {
            logo: _unref(YoutubeLogo),
            title: "Youtube",
            description: _unref(t)('plugins.manager.create.youtube.description'),
            "availability-text": _unref(t)('plugins.manager.create.comingSoon'),
            "is-disabled": true
          }, null, 8, ["logo", "description", "availability-text"]),
          _createVNode(ListItemPluginIntegration, {
            logo: _unref(ShopifyLogo),
            title: "Shopify",
            description: _unref(t)('plugins.manager.create.shopify.description'),
            "availability-text": _unref(t)('plugins.manager.create.comingSoon'),
            "is-disabled": true
          }, null, 8, ["logo", "description", "availability-text"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(RightSideDrawer, {
      show: showInstagramConnectModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showInstagramConnectModal).value = $event)),
      "on-close": instagramConnectClose,
      "bg-color": "bg-gray-100"
    }, {
      header: _withCtx(() => [
        _createVNode(_unref(DialogTitle), { class: "px-4 py-6 sm:px-6" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('plugins.manager.create.title')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('plugins.manager.create.description')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, [
              _createElementVNode("img", {
                class: "size-4",
                src: _unref(InstagramLogo),
                alt: "Instagram logo"
              }, null, 8, _hoisted_9),
              _cache[3] || (_cache[3] = _createTextVNode(" Instagram "))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('plugins.manager.create.details.instagram.description1')), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('plugins.manager.create.details.instagram.description2')), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('plugins.manager.create.details.instagram.description3')), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('plugins.manager.create.details.instagram.description4')), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex items-center rounded-md bg-teal-500 px-3 py-2 text-md font-semibold text-white shadow-xs hover:bg-teal-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500",
                onClick: instagramConnectStart
              }, _toDisplayString(_unref(t)('plugins.manager.create.details.instagram.connect')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(RightSideDrawer, {
      show: showFacebookConnectModal.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showFacebookConnectModal).value = $event)),
      "on-close": facebookConnectClose,
      "bg-color": "bg-gray-100"
    }, {
      header: _withCtx(() => [
        _createVNode(_unref(DialogTitle), { class: "px-4 py-6 sm:px-6" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('plugins.manager.create.title')), 1),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)('plugins.manager.create.description')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h3", _hoisted_20, [
              _createElementVNode("img", {
                class: "size-4",
                src: _unref(FacebookLogo),
                alt: "Facebook logo"
              }, null, 8, _hoisted_21),
              _cache[4] || (_cache[4] = _createTextVNode(" Facebook "))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)('plugins.manager.create.details.facebook.description1')), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(t)('plugins.manager.create.details.facebook.description2')), 1),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)('plugins.manager.create.details.facebook.description3')), 1),
              _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('plugins.manager.create.details.facebook.description4')), 1),
              _createElementVNode("p", {
                class: "p-4 border-dashed border border-gray-200 rounded-md mt-6",
                innerHTML: _unref(t)('plugins.manager.create.details.facebook.warning')
              }, null, 8, _hoisted_27)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-md font-semibold text-white shadow-xs hover:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
                onClick: facebookConnectStart
              }, _toDisplayString(_unref(t)('plugins.manager.create.details.facebook.connect')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})